import { Link } from 'react-router-dom'
import './Hero.css'

const Hero = ({ 
  title = "Servicios Contables Profesionales",
  subtitle = "Más de 10 años de experiencia brindando soluciones contables integrales",
  ctaText = "Consultar Servicios",
  ctaLink = "/contacto",
  showWhatsApp = true 
}) => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero__content">
          <div className="hero__text">
            <h1 className="hero__title">{title}</h1>
            <p className="hero__subtitle">{subtitle}</p>
            
            <div className="hero__ctas">
              <Link to={ctaLink} className="hero__cta hero__cta--primary">
                {ctaText}
              </Link>
              {showWhatsApp && (
                <a 
                  href="https://wa.me/5491166201346" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hero__cta hero__cta--whatsapp"
                >
                  📱 WhatsApp
                </a>
              )}
            </div>
          </div>
          
          <div className="hero__image">
            <img 
              src="/hero-image.jpg" 
              alt="Estudio contable profesional" 
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
